// Copyright (c) 2024 - Present. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted
import { Interval } from 'luxon';

/**
 * Returns an inclusive array of ISO date strings that represent each day in the
 * interval.
 *
 * @param interval - An Interval representing the date range.
 */
export function getDates(interval: Interval) {
  // Add one day to the end of the interval to make the splits include the last
  // date.
  const intervals = interval
    .set({ end: interval.end.plus({ days: 1 }) })
    .splitBy({ days: 1 });

  return intervals.map((range) => range.start.toISODate());
}
